import { useMutation, UseMutationResult } from 'react-query';
import { verifyClaim } from '@creditas-lab/auth-sdk';
import {
  handleMutationError,
  invalidateQuery,
  MutationBaseProps,
} from '../../services/queryClient';
import { ReactQueryKeys } from '../queries/keys';

type VerifyClaimResponse = {
  id: string;
  type: string;
  status?: string;
  taken?: boolean;
  emailAddress?: string;
  phoneNumber?: string;
  phoneAreaCode?: string;
  phoneCountryCode?: string;
};

type VerifyClaimProps = {
  code: string;
  verificationTicket: string;
};

const useVerifyClaim = ({
  onSuccess,
  onError,
}: MutationBaseProps<VerifyClaimResponse> = {}): UseMutationResult<
  VerifyClaimResponse,
  Error,
  VerifyClaimProps
> => {
  return useMutation(
    ({ code, verificationTicket }: VerifyClaimProps) => {
      return verifyClaim(code, verificationTicket);
    },
    {
      onSuccess: (data) => {
        if (onSuccess) {
          onSuccess(data);
        }

        invalidateQuery(ReactQueryKeys.GET_ACCOUNT_INFORMATION);
      },
      onError: handleMutationError(onError),
    },
  );
};

export { useVerifyClaim };
